/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxIsoClosedIcon24Solid = forwardRef('DeliveryBoxIsoClosedIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.322 1.834a3.5 3.5 0 0 1 3.356 0l6.495 3.547c.309.169.585.38.823.623L17.4 7.982 8.435 2.865l1.887-1.031Z" }),
        React.createElement("path", { d: "M6.888 3.71 3.826 5.38a3.497 3.497 0 0 0-.822.623L12 10.952l3.86-2.123-8.972-5.12Z" }),
        React.createElement("path", { d: "m12.75 12.251 9.043-4.973c.132.371.203.768.203 1.175v7.102a3.5 3.5 0 0 1-1.822 3.072l-6.496 3.547a3.5 3.5 0 0 1-.928.347v-10.27Z" }),
        React.createElement("path", { d: "M11.25 12.251v10.27a3.498 3.498 0 0 1-.928-.347l-6.496-3.547a3.5 3.5 0 0 1-1.822-3.072V8.453c0-.407.07-.804.203-1.175l9.043 4.973Z" })));
});
